import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import MVRStatusBadge from 'components/mvr/MVRStatusBadge';
import type { MVRDriverResult } from 'api';
import MvrDownloadButton from './MvrDownloadButton';

interface MvrRequestResultRowProps {
  driver: MVRDriverResult;
  mvrOrderId: number;
}

const MvrRequestResultRow = ({
  driver,
  mvrOrderId,
}: MvrRequestResultRowProps) => {
  const textColor = useColorModeValue('gray.700', 'white');

  return (
    <Flex justify="space-between" align="center" py={2}>
      <Box>
        <Text fontWeight="600" color={textColor}>
          {driver.name || driver.license_number}
        </Text>
        <Text fontSize="sm" color="gray.500">
          {driver.license_number}
        </Text>
        {driver.error_message && (
          <Text fontSize="sm" color="red.500">
            {driver.error_message}
          </Text>
        )}
      </Box>
      <Flex align="center" gap={2}>
        <MVRStatusBadge
          status={driver.status}
          isDuplicate={driver.is_duplicate}
        />
        {driver.pdf_available && (
          <MvrDownloadButton
            mvrOrderId={mvrOrderId}
            mvrRequestId={driver.mvr_request_id}
            licenseNumber={driver.license_number}
          />
        )}
      </Flex>
    </Flex>
  );
};

export default MvrRequestResultRow;
